import React from 'react'
import './About.css'
import aboutImg1 from '../../assets/boys.avif'

const About = () => {
  return (
    <section className="about">
      <h1>About Us</h1>

      <div className="about-content">
        <div className="about-images">
           <img src={aboutImg1} alt="Luxury fashion collection" />
        </div>
        <div className="about-text">
          <p>
            We are a contemporary fashion brand dedicated to refined style,
            exceptional quality, and timeless design. Our collections are
            created for individuals who appreciate elegance, attention to
            detail, and effortless confidence.
          </p>

          <p>
            Each piece is thoughtfully designed and carefully sourced, focusing
            on premium fabrics, precise tailoring, and modern silhouettes. We
            believe true luxury lies in simplicity, comfort, and craftsmanship.
          </p>

          <p>
            Beyond clothing, we aim to deliver a seamless and elevated shopping
            experience—where quality, trust, and style come together. Every
            order reflects our commitment to excellence and our passion for
            modern fashion.
          </p>
        </div>


      </div>
    </section>
  )
}

export default About

